import { authStorage } from 'storages';
import { goToAuth, onRefreshTokensFx } from 'app/services/AuthService/helpers';
import { AuthConfigInterface } from 'app/services/AuthService/AuthConfigInterface';

export const createRefreshAuthLogic = (authConfig: AuthConfigInterface) => {
  const refreshAuthLogic = async () => {
    try {
      const authParams = authStorage.getJwtAuthParams();

      if (authParams?.refresh)
        return await onRefreshTokensFx(authParams.refresh, authConfig);

      if (authConfig.allowAnonymous) return Promise.reject();

      return goToAuth(authConfig);
    } catch (error) {
      goToAuth(authConfig);

      return Promise.reject(error);
    }
  };

  return {
    refreshAuthLogic,
  };
};
